module.exports = __webpack_public_path__ + "img/payroll.372ea3c0.gif";